import { Component, OnInit, Input, OnDestroy, ViewChild, Output, EventEmitter } from "@angular/core";
import { NavigationExtras, Router } from "@angular/router";
// import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
import { Platform, AlertController, MenuController, ModalController, NavController } from "@ionic/angular";
import { Observable, Subscription } from "rxjs";
import { environment } from "../../../environments/environment";
import {
	FuncionesServiceProvider,
	LoaderProvider,
	MenuServiceProvider,
	UsuarioServiceProvider,
} from "src/app/service/index.providers";
import { NotificacionService } from "src/app/service/notificaciones-service/notificacion.service";
import { ApiService } from "src/app/api.service";
import { ConexionServiceProvider, ConnectionStatus } from "src/app/service/conexion-service/conexion-service";
import { OfflineModeService } from 'src/app/service/offline/offline-mode.service';
import { LoginMultiModuloService } from "src/app/service/login-multi-modulo/login-multi-modulo.service";
import { RewardsService } from "src/app/service/rewards/rewards.service";
import { Storage } from '@ionic/storage-angular';
import { LanguageService } from "src/app/service/language-service/language.service";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { AppPlatformService } from "src/app/service/platform/app-platform.service";
import { NotificationsActivitiesService } from "src/app/service/calendar-service/notifications-activities.service";

@Component({
	selector: "app-side-menu-mobile",
	templateUrl: "./side-menu-mobile.component.html",
	styleUrls: ["./side-menu-mobile.component.scss"],
})
export class SideMenuMobileComponent implements OnInit, OnDestroy {
	array_menu2$: Observable<any[]>;
	array_menu2: any;
	data_usuario;
	select_page: String = "anuncios";
	initials: string;
	swipe: boolean = false;
	displayAccordionSection: number | null = null;
	mobile: boolean = false;
	isIos = false;
	groupSelected:number | null = null;
	subGroupSelected:number | null = null;
	newNotification: boolean = false;
	@Input()dataUsuarioProp;
	@Input()initialsProp;

	networkIsActive: boolean = true;
	isCordovaApp: boolean = false;
	lockNetworkToggle: boolean = false;
	private networkObservable: Subscription;
  platformTypeInduction:boolean = false;
  menuGradientActive:boolean;
  modulesOptions = [];
  modulesOptionsIsOpen:boolean = false;
  multiWorkspaceSubs: Subscription;
  IDselectedPlatform;
  IDselectedWorkspace;
  version_usu: string | null = null;
	device_os: string = "web";
  data_empresa;
  configBrandSub: Subscription;
  language:string = "es";
  @Output() menuIsOpen: EventEmitter<any> = new EventEmitter<any>();
  hasChecklistOffline: boolean = false;
  hasCoursesOffline: boolean = false;
  // Plataforma Desempeño: la habilita el flag `has_performance` que envía el backend en
  // la key "usuario" del login. Sin ese flag el acceso no se muestra.
  hasPerformanceModule: boolean = false;
  isPerformanceSelected: boolean = false;
  private userDataSub: Subscription;

	constructor(
		private router: Router,
		private mp: MenuServiceProvider,
		private modalCtrl: ModalController,
		private navCtrl: NavController,
		private up: UsuarioServiceProvider,
		private alertCtrl: AlertController,
		private fp: FuncionesServiceProvider,
		private api: ApiService,
		private menuCtrl: MenuController,
		private platform: Platform,
		private networkService: ConexionServiceProvider,
		private offlineMode: OfflineModeService,
    private loginMultiModuloService: LoginMultiModuloService,
    private loader: LoaderProvider,
    private Storage: Storage,
    private rewardsService: RewardsService,
    private languageService: LanguageService,
    private iab: InAppBrowser,
    private appPlatformService:AppPlatformService,
    private notificationsActivitiesService: NotificationsActivitiesService,


	) {
		if (this.platform.is("cordova") || this.platform.is("mobileweb")) this.mobile = true;
		if (this.platform.is("ios")) this.isIos = true;
		if (this.platform.is("cordova")) {
			this.isCordovaApp = true;
			this.checkNewtworkStatus();
		}

		this.up.isLogged.subscribe((res) => {
			if (res) {
				const user = JSON.parse(localStorage.getItem("user_data"));
				if (user) {
					// console.log("side.ts LOGGED ", this.data_usuario);
					this.data_usuario = user;
					this.initials = this.data_usuario.nombre.charAt(0).toUpperCase() + this.data_usuario.apellido.charAt(0).toUpperCase();
				};

			} else {
				this.data_usuario = null;
				this.initials = "";
			};

			const configData = JSON.parse(localStorage.getItem("config_data"));
			if(configData && configData.is_offline) this.hasCoursesOffline = true;
      if(configData && configData.has_checklist_offline) this.hasChecklistOffline = true;

			// console.log(configData);
      if(this.up.getPlatformType && this.up.getPlatformType === 'induction') {
        this.platformTypeInduction = true;
      }

		});

	}

	ngOnInit() {
    this.subLanguageConfig();
    this.device_os = this.appPlatformService.isIosHibridApp() ? "ios" : this.appPlatformService.isAndroidHibridApp() ? "android" : "web";

    this.version_usu = this.fp.setUserPlatformVersion();
    this.alternativeStyleIsActive();

		this.array_menu2$ = this.fp.getPaginas();
		this.array_menu2$.subscribe((paginas) => {
			this.array_menu2 = paginas;
			//console.log("this.array_menu2:::",this.array_menu2);
		});

		if (!this.array_menu2) this.array_menu2 = this.fp._pages;

		// if (this.array_menu2 && this.networkIsActive && this.isCordovaApp) {
		//  localStorage.setItem("offlineMenu", JSON.stringify(this.array_menu2))
		// } else if(this.isCordovaApp && !this.array_menu2 && !this.networkIsActive && localStorage.getItem("offlineMenu")) {
		// 	this.array_menu2 =  JSON.parse(localStorage.getItem("offlineMenu"));
		// }

		this.select_page = localStorage.getItem("select_page") || "anuncios";
		if (localStorage.getItem("select_group")) this.groupSelected = parseInt(localStorage.getItem("select_group"));
		if (localStorage.getItem("select_sub_group")) this.subGroupSelected = parseInt(localStorage.getItem("select_sub_group"));
		this.mp.select_group.subscribe((index) => (this.groupSelected = index));
		this.mp.select_sub_group.subscribe((index) => (this.subGroupSelected = index));

    this.notificationsActivitiesService.$newNotificationArrived.subscribe((res) => {
      this.newNotification = res;
    });
    this.multiWorkspaceSubs = this.loginMultiModuloService.workspacesList$.subscribe((res) => {
      this.modulesOptions = res;
      if(this.modulesOptions && this.modulesOptions.length) {
        this.getSelectedWorkspace();
      }
    });
    setTimeout(() => {
      if(!this.modulesOptions || this.modulesOptions.length === 0) {
        this.modulesOptions =  JSON.parse(localStorage.getItem("multiWorkspace"));
        this.loginMultiModuloService.setWorkspacesList(this.modulesOptions);
      };
    }, 70);

    this.isPerformanceSelected = localStorage.getItem("isPerformanceAccessSelected") === "true";

    this.configBrandSub = this.up.configBrand.subscribe((res) => {
			this.data_empresa = res;
		});

    // El acceso a Desempeño depende del usuario logueado: se escucha data_usuario$ para
    // que también se refresque tras el login o al cambiar de workspace.
    this.userDataSub = this.up.data_usuario$.subscribe((user) => {
      this.hasPerformanceModule = user?.has_performance === true;
    });


	}

  subLanguageConfig() {
    this.languageService.getCurrentLang().subscribe(lang => {
      this.language = lang;
    });
  }

	checkNewtworkStatus() {
		console.log("sidemenu.ts check network status!!!!");
		this.networkObservable = this.networkService.onNetworkChange().subscribe((status: ConnectionStatus) => {
			if (status == ConnectionStatus.Online) {
				console.log("online sidemenu.ts");
				this.networkIsActive = true;
				//   this.offlineManager.checkForEvents().subscribe();
			} else {
				console.log("offline sidemenu.ts");
				this.networkIsActive = false;
			}
		});
	}

	async toggleNetwork() {
		// networkIsActive: la app está en línea; el interruptor la pasa a «Modo sin conexión» o la devuelve
		const changed = await this.offlineMode.setManualOffline(this.networkIsActive);
		this.lockNetworkToggle = !changed;
		if(changed) {
			this.networkIsActive = !this.networkIsActive;
			console.log("toggle network: ", this.networkIsActive);
		};
	}

	toOfflineCourses() {
		this.router.navigate(['cursos']);
		this.cerrarMenu();
	}

	toOfflineChecklist() {
		this.router.navigate(['lista-checklists']);
		this.cerrarMenu();
	}

	async toPerformanceModule() {
		// Antes de entrar a Desempeño se garantiza su token (se pide solo la primera
		// vez en la sesión; luego se reutiliza el cacheado). Sin token no se navega.
		this.loader.show();
		const tokenReady = await this.loginMultiModuloService.ensurePerformanceToken();
		this.loader.hide();
		if (!tokenReady) {
			this.presentPerformanceTokenError();
			return;
		}
		this.isPerformanceSelected = true;
		localStorage.setItem("isPerformanceAccessSelected", "true");
		// Recuerda que el usuario entró a Desempeño: define su próximo login.
		this.loginMultiModuloService.rememberCurrentPlatform('performance');
		// Reconstruye los menús con los items de la plataforma Desempeño.
		this.fp.cargarFunciones();
		this.router.navigate(['performance']);
		this.cerrarMenu();
	}

	private async presentPerformanceTokenError() {
		const alert = await this.alertCtrl.create({
			header: "",
			message: this.language === 'es'
				? "No se pudo acceder a Desempeño. Inténtalo nuevamente."
				: "Couldn't access Performance. Please try again.",
			mode: "ios",
			buttons: [this.languageService.acceptTranslate(this.language)],
		});
		await alert.present();
	}

	closeModulesOptions() {
		this.modulesOptionsIsOpen = false;
	}

	isWorkspaceSelected(module: any): boolean {
		return !this.isPerformanceSelected
			&& this.IDselectedPlatform === module.platform?.id
			&& this.IDselectedWorkspace === module.subworkspace?.id;
	}

	// Acceso a la plataforma de origen (capacitación/inducción). Solo aplica cuando
	// el usuario no tiene multi-workspace: en ese caso el acceso base no aparece en
	// `modulesOptions` y sin esta entrada no habría forma de volver desde Desempeño.
	get showOriginAccess(): boolean {
		return !(this.modulesOptions && this.modulesOptions.length);
	}

	get isOriginSelected(): boolean {
		return !this.isPerformanceSelected;
	}

	// Label + icono del acceso de origen, según la plataforma preservada en platform_type.
	get originAccess(): { label: string; icon: string } {
		const isInduction = this.up.getPlatformType === 'induction';
		return {
			label: isInduction
				? (this.language === 'es' ? 'Inducción' : 'Onboarding')
				: (this.language === 'es' ? 'Capacitación' : 'Training'),
			icon: isInduction ? 'mdi-card-account-details' : 'mdi-human-male-board',
		};
	}

	// Vuelve a la plataforma de origen desde Desempeño. platform_type se conservó al
	// entrar a Desempeño (toPerformanceModule no lo modifica), así que se reutiliza para
	// decidir la ruta: inducción -> procesos/home; capacitación -> anuncios.
	toOriginPlatform() {
		this.isPerformanceSelected = false;
		localStorage.setItem("isPerformanceAccessSelected", "false");
		// Recuerda que el usuario volvió al origen: define su próximo login.
		this.loginMultiModuloService.rememberCurrentPlatform('origin');
		this.cerrarMenu();
		// Reconstruye los menús con los items de la plataforma de origen.
		this.fp.cargarFunciones();
		if (this.up.getPlatformType === 'induction') {
			const userData = JSON.parse(localStorage.getItem("user_data"));
			const route = userData?.supervisor_induccion ? "procesos" : "home";
			this.mp.setSelectedPageRoute(route);
			this.router.navigate([route]);
		} else {
			this.mp.setSelectedPageRoute("anuncios");
			this.router.navigate(["anuncios"]);
		}
	}

	// Label + icon shown on the closed selector pill for the currently selected access.
	get selectedAccess(): { label: string; icon: string } {
		const performance = { label: this.language === 'es' ? 'Desempeño' : 'Performance', icon: 'mdi-chart-box-outline' };
		if (this.isPerformanceSelected) return performance;

		const module = (this.modulesOptions || []).find((m) =>
			this.IDselectedPlatform === m.platform?.id && this.IDselectedWorkspace === m.subworkspace?.id);
		if (module) {
			return {
				label: `${module.platform?.name} - ${module.subworkspace?.name}`,
				icon: module.platform?.code === 'onboarding' ? 'mdi-card-account-details' : 'mdi-human-male-board',
			};
		}

		// Sin multi-workspace y fuera de Desempeño: el acceso activo es el de origen.
		if (this.showOriginAccess) return this.originAccess;

		if (this.hasPerformanceModule) return performance;
		return { label: this.language === 'es' ? 'Cambiar a' : 'Switch to', icon: 'mdi-swap-horizontal' };
	}

	to(routeLink, groupIndex = null, subGroupIndex = null) {

		groupIndex ? this.groupSelected = groupIndex : this.groupSelected = this.displayAccordionSection;
		this.subGroupSelected = subGroupIndex;

		// if (routeLink == "adjuntar-archivo-from-gestor") {
		// 	let token = localStorage.getItem("token");
		// 	let url = environment.SERVICE_BASE_GESTOR + "adjuntar_archivo?" + "token=" + token;
		// 	console.log(url);
		// 	this.iab.create(url, "_system"); //_blank
		// } else {

			if(routeLink === "induccion"){
				let data_usuario = JSON.parse(localStorage.getItem("user_data"));
				routeLink = data_usuario.supervisor_induccion ? "procesos" : 'home';
				localStorage.setItem("platform_type", 'induction');
				this.fp.cargarFunciones();
			}
			if(routeLink === "aprendizaje"){
				routeLink = "anuncios";
				localStorage.setItem("platform_type", 'capacitacion');
				this.fp.cargarFunciones();
			}

      this.mp.setSelectedPageRoute(routeLink);
			this.mp.select_group.emit(this.groupSelected);
			this.mp.select_sub_group.emit(this.subGroupSelected);
			// this.modalCtrl.dismiss();
			//this.displayAccordionSection = null;
			this.cerrarMenu();
			if (routeLink == "extracurricular" || routeLink == "libres") {
				let extras: NavigationExtras = {
					queryParams: {
						categoria: routeLink,
					},
				};
				this.router.navigate(["progreso"], extras);
			} else {
				this.router.navigate([routeLink]);
			}
		// }
	}

	accordeonActive(index) {
		if(index === this.displayAccordionSection){
			this.displayAccordionSection = null;
		} else{
			this.displayAccordionSection = index;
		}
	}

  alternativeStyleIsActive() {
    this.fp.alternativeStyleSubject$.subscribe(state => {
      this.menuGradientActive = state;
    });
  }

	async confirmarSalir() {
		let alert = await this.alertCtrl.create({
			header: this.languageService.logoutTranslate(this.language).title,
			message:  this.languageService.logoutTranslate(this.language).msg,
			mode: "ios",
			buttons: [
				{
					text: this.languageService.cancelTranslate(this.language),
					role: "cancel",
				},
				{
					text: this.language === 'es' ? "Seguro" : "Log out",
					handler: () => {
						this.cerrarSesion();
					},
				},
			],
		});
		await alert.present();

		this.modalCtrl.getTop().then(top => { if (top) top.dismiss(); });
	}

	async cerrarSesion() {
		this.cerrarMenu();
		await this.api.logout_token()
		.then((res) => {
			this.up.clearStorage();
       if(res.redirect) {
        if(this.appPlatformService.isAppPlatform()) {
          const inAppBrowserRef = this.iab.create(res.redirect, '_blank', 'location=no,hardwareback=no' );
          const loadBrowserSubs = inAppBrowserRef.on('loadstart').subscribe(event => {
            if (event.url.indexOf('login') !== -1 && event.url.indexOf('login.microsoft') === -1) {
                inAppBrowserRef.close();
                const url = new URL(event.url);
                console.log('browser closed - new url!', url);
                const path = url.pathname;
                const query = url.search;
                this.router.navigateByUrl(path + query);
                loadBrowserSubs.unsubscribe();
            };
          });
        } else {
          window.open(res.redirect, "_self");
        }
      } else {
			  this.navCtrl.navigateRoot("login");
      };

		})
		.catch((e) => {
			console.log(e.status, e.url);
		});

	}

	showNotification(){
    this.router.navigate(['/calendar-pending-activities/pending-activity']);
		this.cerrarMenu();
	}

	cerrarMenu() {
		this.menuCtrl.close();
    this.modulesOptionsIsOpen = false;
	}

  showMultimoduleOptions() {
    this.modulesOptionsIsOpen = true;
    this.getSelectedWorkspace();
  }

  selectWorkspace(selectionData) {
    // console.log("selectModule...", selectionData)
    this.isPerformanceSelected = false;
    localStorage.setItem("isPerformanceAccessSelected", "false");
    // Cambiar de workspace también sale de Desempeño: recuerda el origen.
    this.loginMultiModuloService.rememberCurrentPlatform('origin');
    this.modulesOptionsIsOpen = false;
    localStorage.setItem("IDselectedPlatform", JSON.stringify(selectionData.platform?.id));
    localStorage.setItem("IDselectedWorkspace", JSON.stringify(selectionData.subworkspace?.id));
    this.cerrarMenu();
    // Reconstruye el menú normal al salir de Desempeño. Si el workspace requiere
    // login, loginWorkspace() vuelve a llamar cargarFunciones() con la nueva config.
    this.fp.cargarFunciones();
    if(selectionData.is_neccesary_login) this.loginWorkspace(selectionData.subworkspace?.id, selectionData.platform?.id);
  }


  loginWorkspace(subworkspaceId, platformId) {
    this.loader.show();
    this.api.loginSelectedWorkspace(subworkspaceId, platformId, this.device_os, this.version_usu).subscribe(
      {
        next: async (data) => {
          await this.loginMultiModuloService.logoutPreviousSession();
          try {
            console.log(data);
            if(environment.APP_MULTIMARCA) {
              //** seteando url
              this.loginMultiModuloService.saveMultibrandApiUrls(data);
              //** seteando colores
              const resBrandConfig = await this.loginMultiModuloService.getBaseThemeConfig(data?.usuario);
              this.loginMultiModuloService.handleThemeMergeAndApplyFinalTheme(data.custom_ambiente || null, resBrandConfig, false);

              const certificateUrlBase = this.up.getRutaBase;
              if (!certificateUrlBase) { this.up.genera_rutas()	};

              if(data.usuario && !data.recovery) {
                this.fp.setAlternativeStyleState(data.config_data?.has_simple_login);
                this.loginMultiModuloService.setUserProviderConfig(data);
                // FCM token
                if (this.platform.is("cordova")) {
                 // FCM token
                  this.loginMultiModuloService.getFcmToken();
                }


                if(data.usuario.platform_relations && data.usuario.platform_relations.length) {
                  this.loginMultiModuloService.setWorkspacesList(data.usuario.platform_relations);
                  localStorage.setItem("multiWorkspace", JSON.stringify(data.usuario.platform_relations));
                };

                this.loginMultiModuloService.routeUserToPlatform(data.usuario, true);
                this.fp.cargarFunciones();
                if(data.usuario.rewards) {
                  this.rewardsService.rewardReceivedConfirmation(data.usuario.rewards.coins_gained,
                    data.usuario.rewards.coin_name,
                    data.usuario.rewards.path_coins_image,
                    data.usuario.rewards.messages, true
                  );
                };
              };

            }
            else {
                if(data.custom_ambiente) {
                  this.loginMultiModuloService.handleThemeMergeAndApplyFinalTheme(data.custom_ambiente, this.data_empresa, true);
                } else {
                  const resBrandConfig = await this.api.getConfig();
                  this.loginMultiModuloService.handleThemeMergeAndApplyFinalTheme(null, resBrandConfig, true);
                };
                if(data.usuario && !data.recovery){
                  this.fp.setAlternativeStyleState(data.config_data?.has_simple_login);
                  this.loginMultiModuloService.setUserProviderConfig(data);
                  // FCM token
                  this.loginMultiModuloService.getFcmToken();

                  if(data.usuario.platform_relations && data.usuario.platform_relations.length) {
                    this.loginMultiModuloService.setWorkspacesList(data.usuario.platform_relations);
                    localStorage.setItem("multiWorkspace", JSON.stringify(data.usuario.platform_relations));
                  };
                  this.loginMultiModuloService.routeUserToPlatform(data.usuario, true);
                  this.fp.cargarFunciones();
                  if(data.usuario.rewards) {
                    this.rewardsService.rewardReceivedConfirmation(data.usuario.rewards.coins_gained,
                      data.usuario.rewards.coin_name,
                      data.usuario.rewards.path_coins_image,
                      data.usuario.rewards.messages, true
                    );
                  };
                  // this.rewardsService.refreshRewardConfiguration();
                };
            };
            this.loader.hide();
          } catch (error) {
            this.loader.hide();
            console.log(error);
          }
        },
        error: (e) => {
          this.loader.hide();
          console.log(e);
        }
      });
  }

  getSelectedWorkspace() {
    this.IDselectedPlatform = JSON.parse(localStorage.getItem("IDselectedPlatform"));
    this.IDselectedWorkspace = JSON.parse(localStorage.getItem("IDselectedWorkspace"));
    this.isPerformanceSelected = localStorage.getItem("isPerformanceAccessSelected") === "true";
  }

  handleClickedOutside() {
    this.modulesOptionsIsOpen = false;
  }

  onIonDidOpen(e, isOpen) {
    // console.log("@@@@@@@@@menu onIonDidOpen",isOpen)
    this.menuIsOpen.emit(isOpen);
  }

	ngOnDestroy() {
		if(this.networkObservable) this.networkObservable.unsubscribe();
    if(this.multiWorkspaceSubs)this.multiWorkspaceSubs.unsubscribe();
    if(this.configBrandSub)this.configBrandSub.unsubscribe();
    if(this.userDataSub)this.userDataSub.unsubscribe();
	}
}
